import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { SETTINGS_TIPS } from '@/docs/tips/settings';

export const VehiculeCheckTypeTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:inspectionType')}
        thClassName="min-w-[255px]"
        sortable
        onSortClick={() => onSort?.('vehiculeCheckTypeName')}
      />
      <TableHead
        text={t('common:group')}
        thClassName="min-w-[255px]"
        infoTip={SETTINGS_TIPS.inspectionTypeGroupColumn}
      />
      <TableHead text={t('common:status')} thClassName="min-w-0 w-0" />
      <TableHead
        text={t('common:performedBy')}
        thClassName="min-w-0 w-0"
        infoTip={SETTINGS_TIPS.inspectionTypePerformedByColumn}
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
